import { Component } from '@angular/core';

@Component({
  template: '<a-forbidden></a-forbidden>'
})
export class ForbiddenPageComponent {}
